import React, { Component } from "react";
import './BecomePm.scss';
import { useRef } from "react";
import { isAuthorized } from "shared/settings/auth";
import { connect } from "react-redux";
import store from "features/store";
import { useEffect, useState } from "react";
import pmservice from "shared/services/pmservice";
import { logout } from "shared/settings/auth";
import { Button } from "react-bootstrap";
import { removeSideBar, ToggleSideBar, MyAccountMenuList } from "../MyAccountMenuList";
import { Loader } from "shared/hoc/loader/Loader";
import { addDataLayer } from "shared/utils/utils";

export const MembershipLandingPage = (props) => {

    const [pageLoading, setPageLoading] = useState(true);
    const [vipMemberData, setVipMemberData] = useState([])
    const benefitRefs = useRef({});

    useEffect(() => {
        getVipMemberdata();
    }, []);

    const pmNavigatScreen = () => {
        let dataLayerData = {
            'event': 'premier_jointoday'
        }
        addDataLayer(dataLayerData);

        if (!props.user.profilecompleted) {
            return props.history.push('/my-account/my-info/personal-info')
        }
        else if (!props.user.paymentcompleted) {
            return props.history.push('/my-account/my-info/payment-methods')
        }
        else {
            return props.history.push('/my-account/premier-plan')
        }
    }

    useEffect(() => {
        if(isAuthorized()) {
            if (props.user.membershipCompleted) {
                props.history.push("/");
            } else {
                if (props.user.id && !props.user.membershipCompleted) {
                    getVipMemberdata();
                } else {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(props.history, false);
                }
            }
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        }
    }, [props.user.id]);

    const getVipMemberdata = () => {
        pmservice.getContent('become-a-premier-member', "").then((res) => {
            let data = res.data.data[0];
            let jsonContent = JSON.parse(data.jsoncontent)
            setVipMemberData(jsonContent)
            setPageLoading(false)
        }).catch((error) => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
            }
            setPageLoading(false)
        })
    }
    const renderBenefits = (benefits) => {
        let rows = [];
        for (let i = 0; i < benefits.length; i += 3) {
            rows.push(
                <div className="w-100 d-flex justify-content-center">
                    <div className="mt-5 memerbership-serivce" key={i}>
                        {benefits.slice(i, i + 3).map((benefit, index) => (
                            <div key={index} className="membership-service-content d-flex flex-column text-center">
                                <img src={benefit.logo} className="membership-icons" alt="" />
                                <div className="membership-service d-flex flex-column flex-grow-1 text-center">
                                    <div className="service-title fs-20">{benefit.title}</div>
                                    <div>{benefit.description}</div>
                                    <a className="learn-more mt-auto"
                                        style={{ cursor: 'pointer', }} href={`#${benefit.id}`} onClick={(e) => {
                                            e.preventDefault();
                                            const sectionRef = benefitRefs.current[benefit.id];
                                            if (sectionRef?.current) {
                                                sectionRef.current.scrollIntoView({ behavior: 'smooth' });
                                            }
                                        }}>{benefit.link}</a>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            );
        }
        return rows;
    }

    if (vipMemberData.WorthPoint) {
        if (!benefitRefs.current[vipMemberData.WorthPoint.id]) {
            benefitRefs.current[vipMemberData.WorthPoint.id] = React.createRef();
        }
    }

    const footerBtn = () => {
        let dataLayerData = {
            'event': 'premier_jointoday'
        }
        addDataLayer(dataLayerData);
        props.history.push('/my-account/premier-plan')
    }

    return (
        <>
            {pageLoading ?
                <Loader /> :

                <div className="become-a-pm-screen" style={{ scrollBehavior: 'smooth' }}>
                    {vipMemberData.body && <div>

                    <div className="d-flex w-100 membership-join-today justify-content-center mb-5">
                            <div className="d-flex membership-content gap-3 mt-5">
                                <div className="w-25 d-flex flex-column  join-today-section">
                                    <div className="d-flex justify-content-center w-100">
                                        <div className="pm-logo text-center">
                                            <div>
                                                <img src={`${vipMemberData.body.ctbidspmlogo}`} className="membership-img" />
                                            </div>
                                            <div className="divider" style={{ padding: '2px' }}></div>
                                            <div>
                                                <img src={`${vipMemberData.body.shieldlogo}`} className="membership-img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-3 join-today-btn">
                                        <Button onClick={() => pmNavigatScreen()} className="btn btn-primary join-today">
                                            {vipMemberData.body.action.title}
                                        </Button>
                                    </div>
                                </div>

                                <div className="w-75 ml-3 msg-section">
                                    {vipMemberData.body.welcomemsg && <>
                                        {vipMemberData.body.welcomemsg}
                                    </>}
                                </div>
                            </div>
                        </div>

                        <div className="mt-3 membership-benefits-data fs-20" style={{ textAlign: 'center', padding: '20px' }}>
                            <h1 style={{ fontWeight: 'bold', fontSize: '2rem' }}> {vipMemberData.body.benefitDataheading}</h1>
                            {renderBenefits(vipMemberData.body.benefitData)}
                        </div>

                    
                        <div className="d-flex justify-content-center w-100">

                            <div className="p-5 mt-5 benefit-content">

                                <div >
                                    {vipMemberData.benefitsContent.map((section, index) => {
                                        benefitRefs.current[section.id] = benefitRefs.current[section.id] || React.createRef();

                                        return (
                                            <div key={index} id={section.id} ref={benefitRefs.current[section.id]} className="d-flex mb-5">
                                                <div style={{ flex: '0 0 auto' }}>
                                                    <img src={section.logo} alt="logo" style={{ width: '100px' }} />
                                                </div>
                                                <div style={{ flex: '1', margin: '0 1rem' }}>
                                                    {section.title && (
                                                        <div className="font-weight-bold" style={{ color: '#00263E', fontSize: '20px' }}>
                                                            {section.title}
                                                        </div>
                                                    )}
                                                    <div className="mt-3 fs-20">{section.description}</div>
                                                    {section.descriptionPoints && (
                                                        <ul>
                                                            {section.descriptionPoints.map((data, index) => (
                                                                <li className="fs-20" style={{ marginTop: '10px' }} key={index}>{data}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}

                                </div>

                                <div id={`${vipMemberData.WorthPoint.id}`} ref={benefitRefs.current[vipMemberData.WorthPoint.id]}>
                                    <div className="font-weight-bold" style={{ color: '#00263E', fontSize: '1.5rem' }}>{vipMemberData.WorthPoint.title}</div>
                                    <div className="mt-3 mb-3">
                                        <img src={vipMemberData.WorthPoint.logo} alt="logo" className="worthpoint-logo" />
                                    </div>
                                    <div className="worthpoint-content">
                                        {vipMemberData.WorthPoint.description.map((text, index) => (
                                            <p className="mb-3" key={index}>{text}</p>
                                        ))}
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="w-100  d-flex justify-content-center">
                            <div className="footer-content mt-4 pt-3 pb-3 w-75 mb-4">
                                <div className="img-section">
                                    <img src={vipMemberData.footer[0]?.logo} alt="" className="footer-img" />
                                </div>
                                <div className="ml-3 mt-5 mr-3">
                                    <h2 className="text-bold" style={{ fontSize: '20px', fontWeight: 'bold' }}>{vipMemberData.footer[0]?.title}</h2>
                                    <div>{vipMemberData.footer[0]?.subtitle}</div>
                                </div>
                            </div>
                        </div >

                        <div className="w-100 d-flex flex-column align-items-center mb-5">
                            <div className="mt-3 mb-3 d-flex justify-content-center gap-3">
                                <div className="w-100 d-flex justify-content-center">
                                    <div className="pm-ct-logo" >
                                        <img src={vipMemberData.footer[1].ctbidspmlogo} alt="logo" className="w-100" /></div>
                                    <div className="divider"></div>
                                    <div className="shield-logo" >
                                        <img src={vipMemberData.footer[1].shieldlogo} alt="logo" className="w-100" />
                                    </div>
                                </div>
                            </div>
                            <div className="join-today-button">
                                <button onClick={() => footerBtn()} className="btn btn-primary pm-join-today">{vipMemberData.footer[1].action.title}</button>
                            </div>
                        </div>
                    </div>}
                </div>}
        </>
    );
};

class premierMembershipLandingPage extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        ToggleSideBar();
        window.addEventListener('resize', ToggleSideBar);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', ToggleSideBar);
        removeSideBar();
    }


    render() {
        return <MembershipLandingPage {...this.props} />
    }
}

export default connect(state => state)(premierMembershipLandingPage);
